module.exports = __webpack_public_path__ + "img/desain-komunikasi-visual.2f16d197.png";